module.exports = __webpack_public_path__ + "img/isoform_specific_ppi.b4511bec.svg";